export function isFeatureEnabled(featureKey: string) {
  const featureFlag = process.env[`REACT_APP_FEATURE_${featureKey}`]
  return featureFlag === 'true'
}
